<template>
  <div style="position: relative">
    <template v-if="loading">
      <loading-overlay :loading="loading" />
      <h4 class="text-center mt-4 text-muted">جارٍ التحميل ...</h4>
    </template>
    <div v-else-if="content.body" v-html="content.body"></div>
  </div>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    slug: String,
  },
  methods: {
    ...mapActions("Docs", ["getContent"]),
  },
  computed: {
    ...mapGetters("Docs", ["content", "loading"]),
  },
  created() {
    this.getContent(this.slug);
  },
  components: { LoadingOverlay },
};
</script>
